import BaseBehavior from '../../../framework/base/base';
import { debounce } from '../../../shared/utilities/debounce';
import { showElement, hideElement } from '../../../shared/utilities/show-hide';

export default class Input extends BaseBehavior {
	constructor(element) {
		super(element);

		this.initDomCache();
		this.addEventListeners();
	}

	addEventListeners() {
		this.addEventListener(this.dom.query, 'input', () => {
			debounce(() => {
				this.dom.query.value.length ? showElement(this.dom.clear) : hideElement(this.dom.clear);
			}, 100)();
		});

		this.addEventListener(this.dom.clear, 'click', () => {
			this.dom.query.value = '';
			hideElement(this.dom.clear);
		});
	}
}
